import React from 'react';
var BillingToggle = function BillingToggle(_ref) {
  var options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pricing-toggle d-inline-flex align-items-center gap-1 p-1 rounded-pill",
    role: "group",
    "aria-label": "Billing interval"
  }, options.map(function (option) {
    var isActive = option.value === value;
    return /*#__PURE__*/React.createElement("button", {
      key: option.value,
      type: "button",
      "aria-pressed": isActive,
      className: "pricing-toggle-option d-flex align-items-center rounded-pill fw-semibold ".concat(isActive ? 'active' : ''),
      onClick: function onClick() {
        return onChange(option.value);
      }
    }, option.label, option.badge && /*#__PURE__*/React.createElement("span", {
      className: "pricing-toggle-badge rounded-pill fw-bold"
    }, option.badge));
  })));
};
export default BillingToggle;